// translations.js
export const translations = {
  spanish: {
    // Navigation
    backToCases: '← Volver a expedientes',
    
    // Page title and actions
    viewCaseInfo: 'Ver información del expediente',
    publish: 'Publicar',
    startCase: 'Poner en Marcha',
    edit: 'Editar',
    delete: 'Eliminar',
    
    // Case info
    caseNumber: 'Número de expediente',
    type: 'Tipo',
    caseNotFound: 'Expediente no encontrado',
    
    // Status labels
    statusDraft: 'Borrador',
    statusInitiated: 'Iniciado',
    statusProcessing: 'En trámite',
    statusCompleted: 'Finalizado',
    statusDeleted: 'Eliminado',
    
    // Visibility status
    hiddenFromClient: 'Oculto del cliente',
    caseHiddenWarning: 'Este expediente está oculto para el cliente',
    
    // Delete functionality
    confirmDeletion: 'Confirmar Eliminación',
    deletionWarning: 'Estás a punto de eliminar este expediente. Esta acción:',
    willHideFromClient: 'Ocultará el expediente del cliente',
    willDisableAccess: 'Deshabilitará el acceso a todas las funciones',
    willPreserveData: 'Los datos se conservarán en el sistema',
    cannotUndoAction: 'Esta acción no se puede deshacer fácilmente',
    confirmDeleteQuestion: '¿Estás seguro de que deseas eliminar',
    deleteCase: 'Eliminar Expediente',
    deleting: 'Eliminando...',
    caseDeletedSuccessfully: 'Expediente eliminado exitosamente',
    errorDeletingCase: 'Error al eliminar el expediente',
    
    // Progress section
    caseProgress: 'Progreso del expediente',
    start: 'Inicio',
    completion: 'Finalización',
    completed: 'completado',
    
    // Documents section
    caseDocuments: 'Documentos del expediente',
    uploadDocuments: 'Sube documentos relacionados con el expediente',
    addDocument: 'Agregar Documento',
    documentsRelated: 'Documentos relacionados con el expediente',
    noDocumentsYet: 'No hay documentos subidos aún.',
    uploadedOn: 'Subido el',
    uploadedBy: 'Por:',
    
    // Document archive functionality
    activeDocuments: 'Documentos Activos',
    archivedDocuments: 'Documentos Archivados',
    archivedDocumentsDesc: 'Documentos que han sido archivados del expediente. No son visibles para el cliente',
    noArchivedDocuments: 'No hay documentos archivados',
    archiveDocument: 'Archivar documento',
    unarchiveDocument: 'Desarchivar documento',
    confirmArchive: 'Confirmar Archivo',
    archiveDocumentConfirmation: '¿Estás seguro de que deseas archivar este documento?',
    archiveDocumentNote: 'El documento archivado solo será visible para abogados y administradores. Los clientes no podrán verlo.',
    archive: 'Archivar',
    archiving: 'Archivando...',
    archived: 'Archivado',
    errorDownloadingDocument: 'Error al descargar el documento',
    errorArchivingDocument: 'Error al archivar el documento',
    errorUnarchivingDocument: 'Error al desarchivar el documento',
    
    // Appointments section
    appointmentHistory: 'Historial de Citas',
    appointmentHistoryDesc: 'Registro de todas las citas programadas para este expediente',
    manageAppointments: 'Gestionar Citas',
    currentAppointment: 'Cita Vigente',
    active: 'ACTIVA',
    joinMeeting: 'Unirse a la reunión',
    noAppointmentsYet: 'No hay citas registradas aún.',
    meetingLink: '🔗 Enlace de reunión',
    scheduledOn: 'Programada el',
    at: 'a las',
    expired: 'VENCIDA',
    
    // Contact info
    contactInfo: 'Información de contacto',
    lawyerData: 'Datos de su abogado',
    assignedLawyer: 'Abogado Asignado',
    notAssigned: 'Sin asignar',
    notSpecified: 'No especificado',
    openChat: 'Abrir chat',
    
    // Next steps
    nextSteps: 'Próximos pasos',
    pendingActions: 'Acciones pendientes',
    scheduleAppointment: 'Agendar Cita',
    manageAppointment: 'Gestionar Cita',
    nextAppointment: 'Próxima Cita',
    procedureInProgress: 'Trámite en curso',
    checkNotes: 'Consulta notas para detalles',
    attendNextAppointment: 'Asistir a próxima cita',
    checkCalendar: 'Consulta tu calendario de citas',
    
    // Publish modal
    confirmPublication: 'Confirmar Publicación',
    confirmStart: 'Confirmar Puesta en Marcha',
    onPublishing: 'Al publicar este expediente:',
    onStarting: 'Al poner en marcha este expediente:',
    visibleToLawyerClient: '• El expediente será visible para el abogado asignado y el cliente',
    automaticNotification: '• Se enviará una notificación automática a ambas partes',
    statusChangeDraftInitiated: '• El estado cambiará de "Borrador" a "Iniciado"',
    statusChangeInitiatedProcessing: '• El estado cambiará de "Iniciado" a "En Marcha"',
    cannotUndo: '• Esta acción no se puede deshacer',
    lawyerCanAddTasks: '• El abogado podrá agregar y marcar tareas como completadas',
    clientCanCompleteTasks: '• El cliente podrá completar tareas',
    chatEnabled: '• Se habilitará el chat entre abogado y cliente',
    confirmPublishQuestion: '¿Está seguro de que desea publicar el expediente',
    confirmStartQuestion: '¿Está seguro de que desea poner en marcha el expediente',
    cancel: 'Cancelar',
    publishCase: 'Publicar Expediente',
    startCaseAction: 'Poner en Marcha Expediente',
    updating: 'Actualizando...',

    completeCase: 'Finalizar Expediente',

    // Para el modal
    confirmCompletion: 'Confirmar Finalización',
    onCompleting: 'Al finalizar este expediente:',
    caseWillBeCompleted: 'El expediente será marcado como finalizado',
    noMoreEditing: 'No se podrán realizar más modificaciones',
    readOnlyAccess: 'Solo se permitirá acceso de lectura',
    statusChangeProcessingCompleted: 'El estado cambiará de "En Proceso" a "Finalizado"',
    confirmCompleteQuestion: '¿Estás seguro de que deseas finalizar el expediente',
    
    // Para mostrar casos completados
    statusCompleted: 'Finalizado',
    
    // Mensajes informativos
    caseCompletedInfo: 'Este expediente ha sido finalizado y es solo de consulta',

    // Tasks section
    caseTasks: 'Tareas del Expediente',
    manageTasksProgress: 'Gestiona las tareas y su progreso',
    addNewTask: 'Añadir nueva tarea',
    taskDescriptionPlaceholder: 'Descripción de la tarea',
    add: 'Añadir',
    pendingTasks: 'Tareas pendientes',
    completedTasks: 'Tareas completadas',
    completedOn: 'Completada el',
    noTasksCreated: 'No hay tareas creadas para este expediente',

    // Task actions and errors
    userNotAuthenticated: 'Usuario no autenticado',
    errorAddingTask: 'Error al agregar la tarea',
    errorUpdatingTask: 'Error al actualizar la tarea',
    errorDeletingTask: 'Error al eliminar la tarea',

    // Task completion modal
    confirmCompleteTask: 'Confirmar Completar Tarea',
    aboutToCompleteTask: 'Está a punto de marcar como completada la tarea:',
    whenCompletingTask: 'Al completar esta tarea:',
    taskCannotBeEdited: 'La tarea no podrá ser editada posteriormente',
    taskCannotBeUnchecked: 'No se podrá volver a marcar como no completada',
    taskCanOnlyBeDeleted: 'Solo se podrá eliminar si es necesario',
    progressWillBeUpdated: 'Se actualizará automáticamente el progreso total del expediente',
    actionCannotBeUndone: 'Esta acción no se puede deshacer',
    confirmCompleteTaskQuestion: '¿Está seguro de que desea marcar esta tarea como completada?',
    completeTask: 'Completar Tarea',

    // Case Info Modal
    caseInformation: 'Información del Expediente',
    closeModal: 'Cerrar modal',
    description: 'Descripción',
    noDescriptionAvailable: 'Sin descripción disponible',
    caseDetails: 'Detalles del Expediente',
    creationDate: 'Fecha de creación',
    lastModification: 'Última modificación',
    clientDocument: 'Documento del Cliente',
    clientEmail: 'Correo del Cliente',
    notAvailable: 'No disponible',
    close: 'Cerrar',

    // EditCaseModal translations
    editCase: 'Editar expediente',
    editCaseDescription: 'Modifique los datos del expediente',
    caseLanguage: 'Idioma del expediente',
    spanish: 'Español',
    english: 'Inglés',
    caseType: 'Tipo de expediente',
    judicial: 'Judicial',
    administrative: 'Administrativo',
    other: 'Otro',
    title: 'Título',
    status: 'Estado',
    nextAppointmentOptional: 'Próxima Cita (opcional)',
    clientEmailOrDocument: 'Correo o DNI del cliente',
    assignedCollaboratorOptional: 'Colaborador asignado (opcional)',
    userIdentified: 'Usuario identificado',
    userNotIdentified: 'Usuario no identificado',
    selectedClient: 'Cliente Seleccionado',
    assignedPartner: 'Socio Asignado',
    assignedCollaborator: 'Colaborador Asignado',
    saveChanges: 'Guardar Cambios',

    // AppointmentModal translations
    manageAppointment: 'Gestionar Cita',
    currentAppointment: 'Cita Vigente',
    meetingLink: 'Enlace de la reunión',
    cancelAppointment: 'Cancelar Cita',
    noActiveAppointments: 'No hay citas vigentes. Puede programar una nueva cita.',
    scheduleNewAppointment: 'Programar Nueva Cita',
    scheduleAppointment: 'Programar Cita',
    newAppointmentWarning: 'Al programar una nueva cita, la cita vigente será cancelada automáticamente.',
    dateAndTime: 'Fecha y Hora',
    googleMeetLink: 'Enlace de Google Meet',
    scheduling: 'Programando...',
    
    // Form validation
    dateTimeRequired: 'La fecha y hora son requeridas',
    dateTimeMustBeFuture: 'La fecha y hora deben ser en el futuro',
    meetLinkRequired: 'El enlace de Google Meet es requerido',
    meetLinkMustBeValid: 'Debe ser un enlace válido de Google Meet',
  
    // Appointment statuses
    appointmentStatusScheduled: 'Programada',
    appointmentStatusCompleted: 'Completada',
    appointmentStatusCancelled: 'Cancelada',
    
    // Success/Error messages
    appointmentScheduledSuccessfully: 'Cita programada exitosamente',
    errorSchedulingAppointment: 'Error al programar la cita',
    confirmCancelAppointment: '¿Está seguro de que desea cancelar la cita actual?',
    appointmentCancelledSuccessfully: 'Cita cancelada exitosamente',
    errorCancellingAppointment: 'Error al cancelar la cita',
    
    // History
    createdOn: 'Creada el',
    expiredAppointment: 'Cita vencida',

    // ChatModal translations
    caseChat: 'Chat del Expediente',
    participatingAs: 'Participando como',
    administrator: 'Administrador',
    lawyer: 'Abogado',
    client: 'Cliente',
    user: 'Usuario',
    startGroupConversation: '¡Inicia la conversación grupal!',
    allParticipantsCanSee: 'Todos los participantes del expediente podrán ver los mensajes',
    writeMessagePlaceholder: 'Escribe tu mensaje para todos los participantes...',
    sending: 'Enviando...',

    // DocumentUploadModal translations
    uploadDocument: 'Subir Documento',
    noFileSelected: 'No se ha seleccionado ningún archivo',
    fileTooLarge: 'El archivo es demasiado grande. Máximo permitido: 50MB. Tamaño actual:',
    fileTypeNotAllowed: 'Tipo de archivo no permitido. Solo se permiten: PDF, Word, imágenes (JPG, PNG)',
    uploadError: 'Error al subir el archivo. Inténtalo de nuevo.',
    dropFileHere: 'Suelta el archivo aquí',
    dragAndDropFile: 'Arrastra y suelta tu archivo aquí',
    or: 'o',
    selectFromComputer: 'selecciona desde tu computadora',
    allowedFilesInfo: 'Archivos permitidos: PDF, Word, imágenes (JPG, PNG) • Máximo: 50MB',
    uploadingFile: 'Subiendo archivo...',
    fileUploadedSuccessfully: '¡Archivo subido exitosamente!',
    uploadFile: '📤 Subir Archivo',
    uploading: 'Subiendo...',
    close: 'Cerrar',

    readOnly: 'Solo lectura',
    hidden: 'Oculto',
    viewDocuments: 'Ver documentos del expediente',
    viewTasksProgress: 'Ver progreso de las tareas',

    confirmationCheckbox: 'He leído y entiendo las consecuencias de esta acción',
    
    driveWarning: "Los documentos marcados con Google Drive se almacenan en la nube y pueden tardar un momento en prepararse para la descarga.",

    assignedProcuratorOptional: "Procurador Asignado (Opcional)",
    assignedProcurator: "Procurador Asignado",

    reopenCase: 'Reabrir',
    confirmReopening: 'Confirmar Reapertura',
    onReopening: 'Al reabrir este expediente:',
    caseWillBeReopened: 'El expediente volverá al estado "En Proceso"',
    editingWillBeEnabled: 'Se habilitará nuevamente la edición',
    tasksCanBeModified: 'Las tareas podrán ser modificadas',
    chatWillBeEnabled: 'El chat se habilitará nuevamente',
    canBeCompletedAgain: 'Podrá volver a ser completado posteriormente',
    confirmReopenQuestion: '¿Estás seguro de que deseas reabrir',
    reopening: 'Reabriendo...',
    reopenCase: 'Reabrir Expediente',
    caseReopenedSuccessfully: 'Expediente reabierto exitosamente',
    errorReopeningCase: 'Error al reabrir el expediente',
        
    // Days of week
    monday: 'lunes',
    tuesday: 'martes',
    wednesday: 'miércoles',
    thursday: 'jueves',
    friday: 'viernes',
    saturday: 'sábado',
    sunday: 'domingo',
    
    // Months
    january: 'enero',
    february: 'febrero',
    march: 'marzo',
    april: 'abril',
    may: 'mayo',
    june: 'junio',
    july: 'julio',
    august: 'agosto',
    september: 'septiembre',
    october: 'octubre',
    november: 'noviembre',
    december: 'diciembre',
    
    // Common
    loading: 'Cargando...',
    jan: 'ene',
    feb: 'feb',
    mar: 'mar',
    apr: 'abr',
    may: 'may',
    jun: 'jun',
    jul: 'jul',
    aug: 'ago',
    sep: 'sep',
    oct: 'oct',
    nov: 'nov',
    dec: 'dic',

    clientInfo: 'Información del Cliente',
    attorneys: 'Colaboradores',

    taskNotes: 'Notas internas',
    taskNotesPlaceholder: 'Ej: Enviado, esperando respuesta...',
    internalNotes: 'Notas internas',
    hideFromClient: 'Ocultar del cliente',
    showToClient: 'Mostrar al cliente',

    // contact
    contactRegisterTitle: 'Solicitar Acceso a Louw App',
    contactRegisterSubtitle: 'Complete el formulario para solicitar acceso a nuestra plataforma de gestión legal',
    fullNameLabel: 'Nombre completo',
    fullNamePlaceholder: 'Ej: Juan Pérez García',
    fullNameHelper: 'Ingrese su nombre completo como aparece en documentos oficiales',
    emailLabel: 'Correo electrónico',
    emailPlaceholder: 'usuario@ejemplo.com',
    emailHelper: 'Correo donde podremos contactarle',
    userTypeLabel: 'Tipo de usuario',
    roleOfficeLabel: 'Despacho - Equipo legal',
    roleOfficeDesc: 'Despacho de abogados que requiere gestión integral',
    descriptionLabel: 'Descripción de su consulta',
    descriptionPlaceholder: 'Describa sus necesidades, el tipo de casos que maneja, el tamaño de su equipo, funcionalidades específicas que necesita, etc...',
    descriptionHelper: 'caracteres (mínimo 20)',
    whatHappensNext: '¿Qué sucede después?',
    whatHappensNextDesc: 'Nuestro equipo revisará su solicitud y se pondrá en contacto con usted en un plazo de 24-48 horas para proporcionarle información detallada sobre Louw App y cómo puede beneficiar su práctica legal.',
    sendingConsultation: 'Enviando consulta...',
    sendRequest: 'Enviar solicitud',
    formConsentText: 'Al enviar este formulario, acepta que nos pongamos en contacto con usted para proporcionarle información sobre nuestros servicios.',
    consultationSentSuccess: '¡Consulta enviada exitosamente!',
    teamWillContact: 'Nuestro equipo se pondrá en contacto contigo pronto.',
    fullNameRequired: 'El nombre completo es requerido',
    emailRequired: 'El correo electrónico es requerido',
    emailInvalid: 'Por favor ingrese un correo electrónico válido',
    userTypeRequired: 'Debe seleccionar un tipo de usuario',
    descriptionRequired: 'La descripción de su consulta es requerida',
    descriptionMinLength: 'La descripción debe tener al menos 20 caracteres',
    errorSendingConsultation: 'Error al enviar la consulta. Por favor, inténtelo de nuevo.',
  },
  
  english: {
    // Navigation
    backToCases: '← Back to cases',
    
    // Page title and actions
    viewCaseInfo: 'View case information',
    publish: 'Publish',
    startCase: 'Start Case',
    edit: 'Edit',
    delete: 'Delete',
    
    // Case info
    caseNumber: 'Case number',
    type: 'Type',
    caseNotFound: 'Case not found',
    
    // Status labels
    statusDraft: 'Draft',
    statusInitiated: 'Initiated',
    statusProcessing: 'Processing',
    statusCompleted: 'Completed',
    statusDeleted: 'Deleted',
    
    // Visibility status
    hiddenFromClient: 'Hidden from client',
    caseHiddenWarning: 'This case is hidden from the client',
    
    // Delete functionality
    confirmDeletion: 'Confirm Deletion',
    deletionWarning: 'You are about to delete this case. This action:',
    willHideFromClient: 'Will hide the case from the client',
    willDisableAccess: 'Will disable access to all functions',
    willPreserveData: 'The data will be preserved in the system',
    cannotUndoAction: 'This action cannot be easily undone',
    confirmDeleteQuestion: 'Are you sure you want to delete',
    deleteCase: 'Delete Case',
    deleting: 'Deleting...',
    caseDeletedSuccessfully: 'Case deleted successfully',
    errorDeletingCase: 'Error deleting case',
    
    // Progress section
    caseProgress: 'Case progress',
    start: 'Start',
    completion: 'Completion',
    completed: 'completed',
    
    // Documents section
    caseDocuments: 'Case documents',
    uploadDocuments: 'Upload documents related to this case',
    addDocument: 'Add Document',
    documentsRelated: 'Documents related to this case',
    noDocumentsYet: 'No documents uploaded yet.',
    uploadedOn: 'Uploaded on',
    uploadedBy: 'By:',
    
    // Document archive functionality
    activeDocuments: 'Active Documents',
    archivedDocuments: 'Archived Documents',
    archivedDocumentsDesc: 'Documents that have been archived from the case. They are not visible to the client',
    noArchivedDocuments: 'No archived documents',
    archiveDocument: 'Archive document',
    unarchiveDocument: 'Unarchive document',
    confirmArchive: 'Confirm Archive',
    archiveDocumentConfirmation: 'Are you sure you want to archive this document?',
    archiveDocumentNote: 'The archived document will only be visible to lawyers and administrators. Clients will not be able to see it.',
    archive: 'Archive',
    archiving: 'Archiving...',
    archived: 'Archived',
    errorDownloadingDocument: 'Error downloading document',
    errorArchivingDocument: 'Error archiving document',
    errorUnarchivingDocument: 'Error unarchiving document',
    
    // Appointments section
    appointmentHistory: 'Appointment History',
    appointmentHistoryDesc: 'Record of all appointments scheduled for this case',
    manageAppointments: 'Manage Appointments',
    currentAppointment: 'Current Appointment',
    active: 'ACTIVE',
    joinMeeting: 'Join meeting',
    noAppointmentsYet: 'No appointments registered yet.',
    meetingLink: '🔗 Meeting link',
    scheduledOn: 'Scheduled on',
    at: 'at',
    expired: 'EXPIRED',
    
    // Contact info
    contactInfo: 'Contact information',
    lawyerData: 'Your lawyer\'s information',
    assignedLawyer: 'Assigned Lawyer',
    notAssigned: 'Not assigned',
    notSpecified: 'Not specified',
    openChat: 'Open chat',
    
    // Next steps
    nextSteps: 'Next steps',
    pendingActions: 'Pending actions',
    scheduleAppointment: 'Schedule Appointment',
    manageAppointment: 'Manage Appointment',
    nextAppointment: 'Next Appointment',
    procedureInProgress: 'Procedure in progress',
    checkNotes: 'Check notes for details',
    attendNextAppointment: 'Attend next appointment',
    checkCalendar: 'Check your appointment calendar',
    
    // Publish modal
    confirmPublication: 'Confirm Publication',
    confirmStart: 'Confirm Case Start',
    onPublishing: 'By publishing this case:',
    onStarting: 'By starting this case:',
    visibleToLawyerClient: '• The case will be visible to the assigned lawyer and client',
    automaticNotification: '• An automatic notification will be sent to both parties',
    statusChangeDraftInitiated: '• Status will change from "Draft" to "Initiated"',
    statusChangeInitiatedProcessing: '• Status will change from "Initiated" to "Processing"',
    cannotUndo: '• This action cannot be undone',
    lawyerCanAddTasks: '• The lawyer will be able to add and mark tasks as completed',
    clientCanCompleteTasks: '• The client will be able to complete tasks',
    chatEnabled: '• Chat between lawyer and client will be enabled',
    confirmPublishQuestion: 'Are you sure you want to publish the case',
    confirmStartQuestion: 'Are you sure you want to start the case',
    cancel: 'Cancel',
    publishCase: 'Publish Case',
    startCaseAction: 'Start Case',
    updating: 'Updating...',

    // Para el botón
    completeCase: 'Complete Case',
    
    // Para el modal
    confirmCompletion: 'Confirm Completion',
    onCompleting: 'When completing this case:',
    caseWillBeCompleted: 'The case will be marked as completed',
    noMoreEditing: 'No further modifications will be allowed',
    readOnlyAccess: 'Only read-only access will be permitted',
    statusChangeProcessingCompleted: 'Status will change from "Processing" to "Completed"',
    confirmCompleteQuestion: 'Are you sure you want to complete the case',
    
    // Para mostrar casos completados
    statusCompleted: 'Completed',
    
    // Mensajes informativos
    caseCompletedInfo: 'This case has been completed and is for read only',
    
    // Para el área de próximos pasos cuando esté completado
    caseCompleted: 'Case Completed',
    reviewDocuments: 'Review case documents and history',
    contactForNewCase: 'Contact us for a new case',

    // Tasks section
    caseTasks: 'Case Tasks',
    manageTasksProgress: 'Manage tasks and their progress',
    addNewTask: 'Add new task',
    taskDescriptionPlaceholder: 'Task description',
    add: 'Add',
    pendingTasks: 'Pending tasks',
    completedTasks: 'Completed tasks',
    completedOn: 'Completed on',
    noTasksCreated: 'No tasks created for this case',

    // Task actions and errors
    userNotAuthenticated: 'User not authenticated',
    errorAddingTask: 'Error adding task',
    errorUpdatingTask: 'Error updating task',
    errorDeletingTask: 'Error deleting task',

    // Task completion modal
    confirmCompleteTask: 'Confirm Complete Task',
    aboutToCompleteTask: 'You are about to mark as completed the task:',
    whenCompletingTask: 'When completing this task:',
    taskCannotBeEdited: 'The task cannot be edited afterwards',
    taskCannotBeUnchecked: 'It cannot be marked as uncompleted again',
    taskCanOnlyBeDeleted: 'It can only be deleted if necessary',
    progressWillBeUpdated: 'The total case progress will be automatically updated',
    actionCannotBeUndone: 'This action cannot be undone',
    confirmCompleteTaskQuestion: 'Are you sure you want to mark this task as completed?',
    completeTask: 'Complete Task',

    // Case Info Modal
    caseInformation: 'Case Information',
    closeModal: 'Close modal',
    description: 'Description',
    noDescriptionAvailable: 'No description available',
    caseDetails: 'Case Details',
    creationDate: 'Creation date',
    lastModification: 'Last modified',
    clientDocument: 'Client Document',
    clientEmail: 'Client Email',
    notAvailable: 'Not available',
    close: 'Close',

    // EditCaseModal translations
    editCase: 'Edit Case',
    editCaseDescription: 'Modify the case information',
    caseLanguage: 'Case language',
    spanish: 'Spanish',
    english: 'English',
    caseType: 'Case type',
    judicial: 'Judicial',
    administrative: 'Administrative',
    other: 'Other',
    title: 'Title',
    status: 'Status',
    nextAppointmentOptional: 'Next Appointment (optional)',
    clientEmailOrDocument: 'Client email or document',
    assignedCollaboratorOptional: 'Assigned partner (optional)',
    userIdentified: 'User identified',
    userNotIdentified: 'User not identified',
    selectedClient: 'Selected Client',
    assignedPartner: 'Assigned Partner',
    assignedCollaborator: 'Assigned Partner',
    saveChanges: 'Save Changes',

    // AppointmentModal translations
    manageAppointment: 'Manage Appointment',
    currentAppointment: 'Current Appointment',
    meetingLink: 'Meeting link',
    cancelAppointment: 'Cancel Appointment',
    noActiveAppointments: 'No active appointments. You can schedule a new appointment.',
    scheduleNewAppointment: 'Schedule New Appointment',
    scheduleAppointment: 'Schedule Appointment',
    newAppointmentWarning: 'When scheduling a new appointment, the current appointment will be automatically cancelled.',
    dateAndTime: 'Date and Time',
    googleMeetLink: 'Google Meet Link',
    scheduling: 'Scheduling...',
    
    // Form validation
    dateTimeRequired: 'Date and time are required',
    dateTimeMustBeFuture: 'Date and time must be in the future',
    meetLinkRequired: 'Google Meet link is required',
    meetLinkMustBeValid: 'Must be a valid Google Meet link',
    
    // Appointment statuses
    appointmentStatusScheduled: 'Scheduled',
    appointmentStatusCompleted: 'Completed',
    appointmentStatusCancelled: 'Cancelled',
    
    // Success/Error messages
    appointmentScheduledSuccessfully: 'Appointment scheduled successfully',
    errorSchedulingAppointment: 'Error scheduling appointment',
    confirmCancelAppointment: 'Are you sure you want to cancel the current appointment?',
    appointmentCancelledSuccessfully: 'Appointment cancelled successfully',
    errorCancellingAppointment: 'Error cancelling appointment',
    
    // History
    createdOn: 'Created on',
    expiredAppointment: 'Expired appointment',

    // ChatModal translations
    caseChat: 'Case Chat',
    participatingAs: 'Participating as',
    administrator: 'Administrator',
    lawyer: 'Lawyer',
    client: 'Client',
    user: 'User',
    startGroupConversation: 'Start the group conversation!',
    allParticipantsCanSee: 'All case participants will be able to see the messages',
    writeMessagePlaceholder: 'Write your message for all participants...',
    sending: 'Sending...',

    // DocumentUploadModal translations
    uploadDocument: 'Upload Document',
    noFileSelected: 'No file has been selected',
    fileTooLarge: 'File is too large. Maximum allowed: 50MB. Current size:',
    fileTypeNotAllowed: 'File type not allowed. Only PDF, Word, images (JPG, PNG) are permitted',
    uploadError: 'Error uploading file. Please try again.',
    dropFileHere: 'Drop file here',
    dragAndDropFile: 'Drag and drop your file here',
    or: 'or',
    selectFromComputer: 'select from your computer',
    allowedFilesInfo: 'Allowed files: PDF, Word, images (JPG, PNG) • Maximum: 50MB',
    uploadingFile: 'Uploading file...',
    fileUploadedSuccessfully: 'File uploaded successfully!',
    uploadFile: '📤 Upload File',
    uploading: 'Uploading...',
    close: 'Close',

    readOnly: 'Read Only',
    hidden: 'Hidden',
    viewDocuments: 'View case documents',
    viewTasksProgress: 'View tasks progress',

    confirmationCheckbox: 'I have read and understand the consequences of this action',

    driveWarning: 'Documents marked with Google Drive are stored in the cloud and could take longer to download.',

    assignedProcuratorOptional: "Assigned Procurator (Optional)",
    assignedProcurator: "Assigned Procurator",

    reopenCase: 'Reopen',
    confirmReopening: 'Confirm Reopening',
    onReopening: 'When reopening this case:',
    caseWillBeReopened: 'The case will return to "Processing" status',
    editingWillBeEnabled: 'Editing will be enabled again',
    tasksCanBeModified: 'Tasks can be modified',
    chatWillBeEnabled: 'Chat will be enabled again',
    canBeCompletedAgain: 'It can be completed again later',
    confirmReopenQuestion: 'Are you sure you want to reopen',
    reopening: 'Reopening...',
    reopenCase: 'Reopen Case',
    caseReopenedSuccessfully: 'Case reopened successfully',
    errorReopeningCase: 'Error reopening case',
        
    // Days of week
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    
    // Months
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    
    // Common
    loading: 'Loading...',
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mar',
    apr: 'Apr',
    may: 'May',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dec',

    clientInfo: 'Client Information',
    attorneys: 'Attorneys',

    taskNotes: 'Internal notes',
    taskNotesPlaceholder: 'E.g: Sent, waiting for response...',
    internalNotes: 'Internal notes',
    hideFromClient: 'Hide from client',
    showToClient: 'Show to client',

    // contact
    contactRegisterTitle: 'Request Access to Louw App',
    contactRegisterSubtitle: 'Complete the form to request access to our legal management platform',
    fullNameLabel: 'Full name',
    fullNamePlaceholder: 'E.g.: John Smith',
    fullNameHelper: 'Enter your full name as it appears on official documents',
    emailLabel: 'Email address',
    emailPlaceholder: 'user@example.com',
    emailHelper: 'Email where we can reach you',
    userTypeLabel: 'User type',
    roleOfficeLabel: 'Law firm - Legal team',
    roleOfficeDesc: 'Law firm requiring comprehensive management',
    descriptionLabel: 'Description of your inquiry',
    descriptionPlaceholder: 'Describe your needs, the type of cases you handle, your team size, specific features you need, etc...',
    descriptionHelper: 'characters (minimum 20)',
    whatHappensNext: 'What happens next?',
    whatHappensNextDesc: 'Our team will review your request and contact you within 24-48 hours to provide detailed information about Louw App and how it can benefit your legal practice.',
    sendingConsultation: 'Sending inquiry...',
    sendRequest: 'Send request',
    formConsentText: 'By submitting this form, you agree that we may contact you to provide information about our services.',
    consultationSentSuccess: 'Inquiry sent successfully!',
    teamWillContact: 'Our team will get in touch with you soon.',
    fullNameRequired: 'Full name is required',
    emailRequired: 'Email address is required',
    emailInvalid: 'Please enter a valid email address',
    userTypeRequired: 'You must select a user type',
    descriptionRequired: 'A description of your inquiry is required',
    descriptionMinLength: 'The description must be at least 20 characters long',
    errorSendingConsultation: 'Error sending the inquiry. Please try again.',
  }
};

// Hook personalizado para usar las traducciones
export const useTranslations = (language) => {
  const currentLanguage = language === 'english' ? 'english' : 'spanish';
  return translations[currentLanguage];
};